import "babel-polyfill";
import "@mdi/font/css/materialdesignicons.css";
import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import fr from "vuetify/src/locale/fr";
import de from "vuetify/src/locale/de";
import en from "vuetify/src/locale/en";

Vue.use(Vuetify);

const opts = new Vuetify({
  global: {
    ripples: false,
  },
  theme: {
    themes: {
      light: {
        // primary: "#8140C0",
        primary: "#0D47A1",
        secondary: "#26A69A",
        secondaryDarken1: "#1d8179",
        accent: "#1976D2",
        // accent: "#C168D5",
        error: "#C10015",
        info: "#22a7f0",
        sucess: "#26c281",
        warning: "#F2C037",
      },
    },
  },
  lang: {
    locales: { fr, en, de },
    current: "fr",
  },
});
export default new Vuetify(opts);
